import { useEffect } from 'react';

type ClickOutsideHandler = (event: MouseEvent | TouchEvent) => void;

export function useOnClickOutside(
  ref: React.RefObject<HTMLElement>,
  handler: ClickOutsideHandler
) {
  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      const el = ref.current;
      if (!el || el.contains(event.target as Node)) {
        return;
      }
      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener); // for mobile

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
}
